import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Paper,
  Link
} from '@mui/material';

export default function PrivacyPolicy() {
  return (
    <Box sx={{ 
      height: '100%',
      width: '100%',
      overflow: 'auto',
      bgcolor: 'background.default',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }}>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Privacy Policy
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
            Data Collection and Usage
          </Typography>
          <Typography paragraph>
            Postbox Explorer collects and processes the following information:
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                <strong>Location Data:</strong> We collect your location data to show nearby postboxes and provide directions. This data is only used while you are actively using the application and is not stored permanently.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                <strong>Photos:</strong> When you upload photos of postboxes, they are stored securely and may be publicly visible to other users. You retain ownership of your photos.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                <strong>User Information:</strong> We collect basic profile information from your Google account (name and profile picture) to personalize your experience and manage your contributions.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                <strong>Postbox Data:</strong> Information about postboxes you add, including location, description, and photos, is stored and may be publicly visible.
              </Typography>
            </li>
          </ul>

          <Typography variant="h6" gutterBottom>
            Data Protection
          </Typography>
          <Typography paragraph>
            We implement appropriate security measures to protect your data. Your information is stored securely using industry-standard encryption and security practices.
          </Typography>

          <Typography variant="h6" gutterBottom>
            Third-Party Services
          </Typography>
          <Typography paragraph>
            We use the following third-party services:
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                <strong>Google:</strong> For authentication and maps integration
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                <strong>OpenStreetMap:</strong> For map data and location services
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                <strong>Appwrite:</strong> For backend services and data storage
              </Typography>
            </li>
          </ul>

          <Typography variant="h6" gutterBottom>
            Your Rights
          </Typography>
          <Typography paragraph>
            You have the right to:
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                Access your personal data
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Delete your account and associated data
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Opt out of location tracking
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Remove your contributions
              </Typography>
            </li>
          </ul>

          <Typography variant="h6" gutterBottom>
            Contact
          </Typography>
          <Typography paragraph>
            If you have any questions about this privacy policy or your data, please contact us at{' '}
            <Link href="mailto:privacy@postbox-explorer.com">
              privacy@postbox-explorer.com
            </Link>
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
} 